// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl, getToken } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchNVRManufactures(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvrManufactures}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function uploadNVR(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvrUpload}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
    ...(options || {}),
  });
}

export async function exportSampleNVR(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvrSampleExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function refreshNVR({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvrRefresh(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchNVR(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.nvr()}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addNVR(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvr()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteNVR(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvr(id)}`, {
    method: 'DELETE',
  });
}

export async function updateNVR({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nvr(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchCameraGroups(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraGroups}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchCameraEvents(id: string | number, options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraEvents(id)}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchCameras(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.cameras}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addCamera(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.camera()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteCamera(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.camera(id)}`, {
    method: 'DELETE',
  });
}

export async function deleteCameras(ids: (string | number)[] = []) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraDelete}`, {
    method: 'DELETE',
    data: ids,
  });
}

export async function activateCamera(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraActivate(id)}`, {
    method: 'PUT',
  });
}

export async function activateCameras(data?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraActivate()}`, {
    method: 'PUT',
    data,
  });
}

export async function updateCamera({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.camera(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchCamera(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.camera(id)}`, {
    method: 'GET',
  });
}

export async function fetchCameraSnapshot(id: string | number, options?: { [key: string]: any }) {
  return request<Blob>(`${apiProxy}${apiUrl.cameraSnapshot(id)}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob',
    ...(options || {}),
  });
}

export async function uploadCameras(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraUpload}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
    ...(options || {}),
  });
}

export async function exportSampleCameras(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraSampleExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function exportCameras(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function updateCameraDrawbox(id: string | number, data: any) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraDrawbox(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function updateCameraDrawboxMulti(id: string | number, data: any) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraDrawboxMulti(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function updateCameraDrawboxUnified(id: string | number, data: any) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.cameraDrawboxUnified(id)}`, {
    method: 'PUT',
    data,
  });
}
